export const NOMENCLATURE_TRANSFER_DEFAULT_FORM = {
  date: '',
  sourceFactoryId: null,
  destinationFactoryId: null,
  nomenclatureId: null,
  unitId: null,
  driverSalary: 0,
  comment: '',
  status: null,
};
